import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_TITLE
} from "../../constants/home_match_basic_resignation";
import {useHomeMatchBasicResignationActions} from "../../hooks/use_home_match_basic_resignation_actions";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {HomeMatchBasicPreferencesFlowResignationDescription} from "./HomeMatchBasicPreferencesFlowResignationDescription";

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
    overlayVariant?: IModalOverlayVariant;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowResignationModal = (props: IProps) => {
    const {isOpen, isSaving, overlayVariant, zIndex} = props;
    const {isKeepEnabledLoading, isDisableLoading, handleClose, handleKeepEnabled, handleDisable} = useHomeMatchBasicResignationActions(props);

    return (
        <Modal
            isOpen={isOpen}
            className={resignationModalStyle}
            onModalClose={handleClose}
            overlayVariant={overlayVariant}
            {...(zIndex === undefined ? {} : {zIndex})}
        >
            <Modal.CloseButton placement="right" variant="rounded" className={closeButtonStyle} />
            <Modal.Content className={resignationContentStyle}>
                <Text variant="headline_3" as="h2" className={resignationHeaderStyle}>
                    {HOME_MATCH_BASIC_RESIGNATION_TITLE}
                </Text>
                <Text variant="body_copy_2" color="var(--colors-gray-800)">
                    <HomeMatchBasicPreferencesFlowResignationDescription />
                </Text>
                <div className={resignationActionsStyle}>
                    <Button
                        variant="filled_primary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleKeepEnabled}
                        disabled={isSaving}
                        isLoading={isKeepEnabledLoading}
                    >
                        <span className={buttonTextStyle}>{HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT}</span>
                    </Button>
                    <Button
                        variant="outlined_secondary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleDisable}
                        disabled={isSaving}
                        isLoading={isDisableLoading}
                    >
                        <span className={buttonTextStyle}>{HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT}</span>
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const resignationModalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    },
    md: {
        width: "544px"
    }
});

const closeButtonStyle = css({
    m: 2
});

const resignationContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    pb: 20,

    sm: {
        p: 3
    }
});

const resignationHeaderStyle = css({
    mb: 1,
    pr: "4rem"
});

const resignationActionsStyle = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 2,
    p: 3,
    backgroundColor: "var(--colors-white)",
    zIndex: 10,

    sm: {
        position: "static",
        gridTemplateColumns: "1fr",
        p: 0,
        mt: 3
    }
});

const buttonStyle = css({
    width: "100%"
});

const buttonTextStyle = css({
    "@media (max-width: 375px)": {
        fontSize: "1.4rem"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {type IModalOverlayVariant, Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT,
    HOME_MATCH_BASIC_RESIGNATION_TITLE
} from "../../constants/home_match_basic_resignation";
import {useHomeMatchBasicResignationActions} from "../../hooks/use_home_match_basic_resignation_actions";
import type {
    IHomeMatchBasicPreferencesFlowAmplitudeItemContext,
    IHomeMatchBasicPreferencesFlowTrackingContext
} from "../../types/HomeMatchBasicPreferencesFlowTypes";
import {HomeMatchBasicPreferencesFlowResignationDescription} from "./HomeMatchBasicPreferencesFlowResignationDescription";

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    amplitudeItemContext?: IHomeMatchBasicPreferencesFlowAmplitudeItemContext;
    overlayVariant?: IModalOverlayVariant;
    zIndex?: number;
}

export const HomeMatchBasicPreferencesFlowResignationModal = (props: IProps) => {
    const {isOpen, isSaving, overlayVariant, zIndex} = props;
    const {isKeepEnabledLoading, isDisableLoading, handleClose, handleKeepEnabled, handleDisable} = useHomeMatchBasicResignationActions(props);

    return (
        <Modal
            isOpen={isOpen}
            className={resignationModalStyle}
            onModalClose={handleClose}
            overlayVariant={overlayVariant}
            {...(zIndex === undefined ? {} : {zIndex})}
        >
            <Modal.CloseButton placement="right" variant="rounded" className={closeButtonStyle} />
            <Modal.Content className={resignationContentStyle}>
                <Text variant="headline_3" as="h2" className={resignationHeaderStyle}>
                    {HOME_MATCH_BASIC_RESIGNATION_TITLE}
                </Text>
                <Text variant="body_copy_2" color="var(--colors-gray-800)">
                    <HomeMatchBasicPreferencesFlowResignationDescription />
                </Text>
                <div className={resignationActionsStyle}>
                    <Button
                        variant="filled_primary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleKeepEnabled}
                        disabled={isSaving}
                        isLoading={isKeepEnabledLoading}
                    >
                        <span className={buttonTextStyle}>{HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT}</span>
                    </Button>
                    <Button
                        variant="outlined_secondary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleDisable}
                        disabled={isSaving}
                        isLoading={isDisableLoading}
                    >
                        <span className={buttonTextStyle}>{HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT}</span>
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const resignationModalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    },
    md: {
        width: "544px"
    }
});

const closeButtonStyle = css({
    m: 2
});

const resignationContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    pb: 20,

    sm: {
        p: 3
    }
});

const resignationHeaderStyle = css({
    mb: 1,
    pr: "4rem"
});

const resignationActionsStyle = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 2,
    p: 3,
    backgroundColor: "var(--colors-white)",
    zIndex: 10,

    sm: {
        position: "static",
        gridTemplateColumns: "1fr",
        p: 0,
        mt: 3
    }
});

const buttonStyle = css({
    width: "100%"
});

const buttonTextStyle = css({
    "@media (max-width: 375px)": {
        fontSize: "1.4rem"
    }
});
